import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { CategoryProvider } from './contexts/CategoryContext';
import { RecipeProvider } from './contexts/RecipeContext';
import { ConflictResolutionProvider } from './contexts/ConflictResolutionContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles/tokens.css';

// 🔒 SECURITY & PRIVACY: Disable console logging in production for GDPR compliance
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.info = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <CategoryProvider>
            <RecipeProvider>
              <ConflictResolutionProvider>
                <App />
              </ConflictResolutionProvider>
            </RecipeProvider>
          </CategoryProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// PWA Service Worker Registration
// Aktiviert Offline-Funktionalität und Caching
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('[MyBoki] PWA erfolgreich installiert. Offline-Modus verfügbar.');
  },
  onUpdate: (registration) => {
    console.log('[MyBoki] Neue Version verfügbar. Bitte Seite neu laden.');
    // Optional: Zeige dem Benutzer eine Benachrichtigung
    if (window.confirm('Eine neue Version von MyBoki ist verfügbar. Jetzt aktualisieren?')) {
      serviceWorkerRegistration.forceUpdate();
      window.location.reload();
    }
  }
});
